import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit} from '@angular/core';
import {DetectMethodChanges, isVoid} from "../../../../utils";
import {HedgeItemToTrack} from "../../../../shell-communication/shell-dto-protocol";
import {ApgPortfolio} from "../../../model/ApgPortfolio";
import {AdjustmentPricingGridComponent} from "../../../adjustment-pricing-grid.component";

@Component({
    selector: 'ets-hedges-total-sweet-price',
    template: `
      <fieldset class="by-expiration-block">
        <legend class="by-expiration-title">
          {{ this.hedgeTrackingGroup?.header }}
        </legend>

        <ng-container *ngIf="this.global">
          <div class="global inputs">
            <div class="total hedge" *ngFor="let item of this.hedgeTrackingGroup?.totals">
              <div class="checkbox">
                <dx-check-box [(value)]="item.enabled"
                              (onValueChanged)="this.hedgeTrackingGroup?.onCheckboxToggled(item)">
                </dx-check-box>
              </div>

              <div class="label">
                {{ item.label }}
              </div>

              <div [ngClass]="this.getHedgeCssClass(item.label.toLowerCase())">
                {{ this.getTotalHedgesPrice(item.label.toLowerCase()) | currency }}
              </div>

              <div class="sweet-price">
                <dx-number-box width="100%"
                               [disabled]="!item.enabled"
                               [(value)]="item.sweetPrice"
                               (onValueChanged)="this.onChange()"
                               format="$#0.00"
                               [inputAttr]="{style: 'text-align: center;'}"
                ></dx-number-box>
              </div>
            </div>
          </div>
        </ng-container>

      <!-- Individual Hedges        -->
        <ng-container *ngIf="!this.global">

          <div class="inputs">

            <div class="group totals">
              <div class="header">
                Totals
              </div>
              <div class="individuals">
                <div class="total hedge" *ngFor="let item of this.hedgeTrackingGroup?.totals">
                  <div class="checkbox">
                    <dx-check-box [(value)]="item.enabled"
                                  (onValueChanged)="this.hedgeTrackingGroup?.onCheckboxToggled(item)">
                    </dx-check-box>
                  </div>
                  <div class="label">
                    {{ item.label }}
                  </div>
                  <div class="price">
                    <dx-number-box width="100%"
                                   [disabled]="!item.enabled"
                                   [(value)]="item.sweetPrice"
                                   (onValueChanged)="this.onChange()"
                                   format="$#0.00"
                                   [inputAttr]="{style: 'text-align: center;'}"
                    ></dx-number-box>
                  </div>
                </div>
              </div>
            </div>

            <div class="group calls">
              <div class="header">
                Calls
              </div>
              <div class="individuals">
                <div class="hedge" *ngFor="let item of this.hedgeTrackingGroup?.calls">
                  <div class="checkbox">
                    <dx-check-box [(value)]="item.enabled"
                                  (onValueChanged)="this.hedgeTrackingGroup?.onCheckboxToggled(item)">
                    </dx-check-box>
                  </div>
                  <div #label class="label" [style.color]="item.color">
                    {{ item.label }} <span class="calendarized" *ngIf="item.calendarized">CAL</span>
                    <ng-container *ngIf="item.calendarized">
                      <dx-popover
                        [target]="label"
                        showEvent="dxhoverstart"
                        hideEvent="dxhoverend"
                      >
                        <div *dxTemplate="let data of 'content'" class="cal-expirations">
                          <div class="cal-expiration" *ngFor="let calExp of item.calExpirations">
                            {{ calExp }}
                          </div>
                        </div>
                      </dx-popover>
                    </ng-container>
                  </div>
                  
                  <div [ngClass]="this.getHedgeCssClass(item.individualId)">
                    {{ this.getHedgePrice(item.individualId) | currency }}
                  </div>
                  
                  <div class="price">
                    <dx-number-box width="100%"
                                   [disabled]="!item.enabled"
                                   [(value)]="item.sweetPrice"
                                   (onValueChanged)="this.onChange()"
                                   format="$#0.00"
                                   [inputAttr]="{style: 'text-align: center;'}"
                    ></dx-number-box>
                  </div>
                </div>
              </div>
            </div>

            <div class="group puts">
              <div class="header">
                Puts
              </div>
              <div class="individuals">
                <div class="hedge" *ngFor="let item of this.hedgeTrackingGroup?.puts">
                  <div class="checkbox">
                    <dx-check-box [(value)]="item.enabled"
                                  (onValueChanged)="this.hedgeTrackingGroup?.onCheckboxToggled(item)">
                    </dx-check-box>
                  </div>

                  <div #label class="label" [style.color]="item.color">
                    {{ item.label }} <span class="calendarized" *ngIf="item.calendarized">CAL</span>
                    <ng-container *ngIf="item.calendarized">
                      <dx-popover
                        [target]="label"
                        showEvent="dxhoverstart"
                        hideEvent="dxhoverend"
                      >
                        <div *dxTemplate="let data of 'content'" class="cal-expirations">
                          <div class="cal-expiration" *ngFor="let calExp of item.calExpirations">
                            {{ calExp }}
                          </div>
                        </div>
                      </dx-popover>
                    </ng-container>
                  </div>

                  <div [ngClass]="this.getHedgeCssClass(item.individualId)">
                    {{ this.getHedgePrice(item.individualId) | currency }}
                  </div>

                  <div class="sweet-price">
                    <dx-number-box width="100%"
                                   [disabled]="!item.enabled"
                                   [(value)]="item.sweetPrice"
                                   (onValueChanged)="this.onChange()"
                                   format="$#0.00"
                                   [inputAttr]="{style: 'text-align: center;'}"
                    ></dx-number-box>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

      </fieldset>
    `,
    styles: [`

        .global .hedge {
            flex: 1;
        }

        .global .hedge .label {
            font-weight: 800;
        }

        .by-expiration-block {
            margin-bottom: 15px;
        }

        .by-expiration-title {
            font-size: 1.1em;
            font-weight: bold;
        }

        .inputs {
            display: flex;
            column-gap: 10px;
            align-items: flex-start;
            justify-content: center;
            padding: 5px 0;
        }

        .group {
            flex: 10;
        }
        
        .group.totals {
            flex: 5;
        }

        .group .header {
            text-align: center;
            font-weight: 800;
            font-size: 1.2em;

            border-bottom: 1px solid white;
            width: 80%;
            margin: auto auto 10px;
            padding-bottom: 5px;
        }

        .hedge {
            display: flex;
            column-gap: 5px;
            margin-bottom: 3px;
            align-items: center;

            .label {
                flex: 1;
            }
            
            .label {
                .calendarized {
                    font-size: 0.65em;
                    font-weight: bold;
                    vertical-align: super;
                    text-transform: uppercase;

                    cursor: pointer;
                }
            }
            
            .price {
                text-align: right;
                flex: 0;
                min-width: 65px;
                padding-right: 5px;
            }

            .sweet-price {
                flex: 0;
                min-width: 65px;
                max-width: 65px;
            }
        }

        .individuals {
            display: flex;
            flex-direction: column;
        }

        .cal-expirations {
            display: flex;
            flex-direction: column;
            row-gap: 10px;
            align-items: center;
            padding: 10px;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class HedgesTotalSweetPriceComponent implements OnInit {

    constructor(
        private readonly _changeDetector: ChangeDetectorRef
    ) {
    }


    private _hedgeTrackingGroup: HedgeTrackingGroup;
    get hedgeTrackingGroup(): HedgeTrackingGroup {
        return this._hedgeTrackingGroup;
    }

    @Input()
    set hedgeTrackingGroup(value: HedgeTrackingGroup) {
        this._hedgeTrackingGroup = value;
        if (this._hedgeTrackingGroup) {
            this._hedgeTrackingGroup.somethingChanged$.subscribe(() => {
                this.onChange();
            });

        }
    }

    @Input() global: boolean;

    @Input() context!: AdjustmentPricingGridComponent;

    ngOnInit() {
        this.context?.hedgesTotalCmp?.hedgePricingService?.hedgePriceChanged$.subscribe(() => {
            this.onChange();
        });
    }

    @DetectMethodChanges()
    onChange() {
    }

    getHedgePrice(hedgeId: string) {
        const px = this.context?.hedgesTotalCmp?.hedgePricingService?.getHedgeGroupCost(hedgeId);
        return px;
    }

    getTotalHedgesPrice(type: "calls" | "puts" | "total") {

        const portfolio = this.context?.getSelectedPortfolio();

        if (isVoid(portfolio)) {
            return undefined;
        }

        const pfKey = `${portfolio.userId}@${portfolio.id}`;
        const px = this.context?.hedgesTotalCmp?.hedgePricingService?.getHedgesCost(pfKey, type);
        return px;
    }

    getHedgeCssClass(hedgeId: string) {

        const classes: string[] = ['price'];

        let px = undefined;
        if (hedgeId === 'calls' || hedgeId === 'total' || hedgeId === 'puts') {
            px = this.getTotalHedgesPrice(hedgeId);
        } else {
            px = this.getHedgePrice(hedgeId);
        }
        if (px > 0) {
            classes.push('ets-positive-number');
        } else if (px < 0) {
            classes.push('ets-negative-number');
        }

        return classes;
    }
}


export class HedgeTrackingGroup {

    constructor(
        public readonly expiration?: string,
    ) {
        this.totals = [
            {
                label: 'Calls',
                aggregationType: !expiration ? 'global' : 'expiration',
                expiration: expiration,
                itemType: 'aggregate',
                optionType: 'Call',
                enabled: false
            },
            {
                label: 'Puts',
                aggregationType: !expiration ? 'global' : 'expiration',
                expiration: expiration,
                itemType: 'aggregate',
                optionType: 'Put',
                enabled: false
            },
            {
                label: 'Total',
                aggregationType: !expiration ? 'global' : 'expiration',
                expiration: expiration,
                itemType: 'aggregate',
                optionType: 'Total',
                enabled: false
            },
        ];
    }


    portfolio: ApgPortfolio;

    somethingChanged$ = new EventEmitter();

    header: string;

    totals: HedgeItemToTrack[] = [];

    calls: HedgeItemToTrack[] = [];

    puts: HedgeItemToTrack[] = [];

    onCheckboxToggled(item: HedgeItemToTrack) {
        if (!item.enabled) {
            item.sweetPrice = null;
        }
        this.onChange();
    }

    onChange() {
        this.somethingChanged$.emit();
    }

    getItemsToTrack(): HedgeItemToTrack[] {
        const totals = this.totals.filter(x => x.enabled);
        const calls = this.calls.filter(x => x.enabled);
        const puts = this.puts.filter(x => x.enabled);

        const hedgeItemToTracks = totals.concat(calls).concat(puts);

        return hedgeItemToTracks;
    }

    getHedgesOfTheGroup() {
        const hedges = this.calls.map(x => x.individualId)
            .concat(this.puts.map(x => x.individualId));
        return hedges;
    }

    removeItemToTrack(h: string) {
        this.removeFromArray(this.totals, h);
        this.removeFromArray(this.calls, h);
        this.removeFromArray(this.puts, h);
    }

    private removeFromArray(array: HedgeItemToTrack[], item: string) {
        const ix = array.findIndex(x => x.individualId === item);
        if (ix === -1) {
            return;
        }
        array.splice(ix, 1);
    }
}
